import { ReactComponent as LoadingSvg } from '../assets/img/spin-1s-200px.svg'
import React from 'react'

export default ({ message }) => <div>
  <LoadingSvg style={{ maxWidth: '400px' }} className="img-fluid mx-auto d-block" />
  <h1 className="text-center display-5">{message}</h1>
</div>
